import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import Loader from '../components/Loader';

class PostcodeCheckerDoorToDoor extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let postcode = ''
        let city = ''
        let loading = false;
        let suggest = ''

        this.state = {
            postcode,
            loading,
            city,
            suggest,
            invalidPostcode: false
        };
    }

    componentWillMount(){
    }

    componentDidMount() {
    }

    handlePostcode = () => {

        const { params: { vendor } } = this.props;
        let { postcode } = this.state;

        if (!postcode) {
            return;
        }

        this.setState({ loading: true });
        this.setState({ suggest: '' })

        return api('/api/lookup/doortodoor/postcode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                postcode,
                vendor
            })
        }).then(result => {


            if(result){
                this.setState({
                result: result.result,
                city: result.city,
                invalidPostcode: false });

                window.parent.postMessage({ zone: result.result }, "https://giftr.my");
            } else {
                this.setState({ invalidPostcode: true,
                    result: undefined
                 });
            }

            if (result.result.toLowerCase().includes('sorry')) {
                return api(`/api/lookup/vendor/${postcode}`, {
                    method: 'GET',
                    headers: {'Content-Type': 'application/json'}
                }).then(res => {
                    this.setState({ loading: false });

                    this.setState({ suggest: `https://giftr.my/pages/search-results-page?${res.additional_params}&page=1&rb_filter_ptag_97d68d9098015602983184c1f01bf156=${result.city}%7CNationwide&sort_by=total_reviews` })
                    // this.setState({ suggest: `https://giftr.my/pages/search-results-page?${res.additional_params}&page=1&rb_price=30%2C3000&rb_vendor=${res.vendors}` })
                });
            }
            this.setState({ loading: false });
        })
    }

    handlePostcodeChange = (event) => {
        this.setState({ postcode: event.target.value });
    }

    handleEnterPress = (e) => {
        if(e.key === "Enter"){
            this.handlePostcode();
        }
    }

    render() {
        const { error } = this.props
        const { postcode, city, loading, result, invalidPostcode, suggest } = this.state;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            <label className="sub-header">Delivery Area Checker</label>
                            <div className="row">
                                {/* <div className="col-xs-12">
                                {
                                    !result &&
                                    <span>Enter your delivery postcode</span>
                                }
                                </div> */}
                                <div className="col-xs-9">
                                    <div className="form-group">
                                        <input className="form-control" placeholder="Enter postcode" type="text" onChange={this.handlePostcodeChange} onKeyPress={this.handleEnterPress}/>
                                    </div>
                                </div>
                                <div className="col-xs-3">
                                    <Button className="btn-postcode-checker" onClick={this.handlePostcode} block disabled={loading} >{loading ? 'Loading...' : 'Apply'}</Button>
                                </div>
                            </div>
                            {
                                loading &&
                                <Loader />
                            }
                            {
                                !result && !invalidPostcode &&
                                <div>
                                    <p>Enter the postcode of shipping address to check on the delivery area & availability. Price may vary based on different zones.</p>
                                </div>
                            }
                            {
                                !loading && result &&
                                <div>
                                    <p style={{margin: '0'}}>Ship to: <b>{city}</b></p>
                                    <p style={{display: 'flex'}}>Availability:
                                        <b style={{marginLeft: '3px'}}>
                                            {result}{suggest !== '' && <div>Kindly check out available products <a href={suggest} target='_blank'>here</a></div>}
                                        </b>
                                    </p>
                                </div>
                            }
                            {
                                invalidPostcode &&
                                <div>
                                    <p>You entered an invalid postcode. Please try again.</p>
                                </div>
                            }

                            <hr/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {

    };
})(PostcodeCheckerDoorToDoor);
